<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-button
            size="sm"
            class="btn-success mb-2 float-right"
            @click="Add"
        >
          Neuen Pushover Account
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-table
            striped
            hover
            responsive
            :items="pushoverList"
            :fields="fields"
            @row-clicked="ClickRow"
        >
        </b-table>
      </b-col>
    </b-row>

    <b-modal
        hide-footer
        id="modal-edit-pushover"
        centered
        size="lg"
        :title="modalText"
    >
      <b-row>

        <b-col
            md="4"
            xl="4"
            class="mb-1"
        >
          <b-form-group
              label="Name"
          >
            <b-form-input
                v-model="edit.Name"
            />
          </b-form-group>
        </b-col>
        <b-col
            md="8"
            xl="8"
            class="mb-1"
        >
          <b-form-group
              label="Key"
          >
            <b-form-input
                v-model="edit.Key"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
              size="sm"
              variant="gradient-danger"
              class="btn-icon float-left"
              @dblclick="Delete()"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.v-warning
              title="Zum Löschen 2 mal Klicken!"
          >
            <feather-icon icon="Trash2Icon"/>
          </b-button>
          <b-button class="float-right" variant="success" @click="Save">
            OK
          </b-button>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok, cancel}">
        <div>

        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BFormDatepicker, VBTooltip
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Driver',
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      pushoverLogo: require('@/assets/images/logo/pushover-logo.svg'),
      modalText: 'Neuer Pushover Account',
      edit: {
        Name: '',
        Key: '',
        IdentId: 0
      },
      pushoverList: [],
      fields: [
        {
          key: 'IdentId',
          label: 'Id'
        },
        {
          key: 'Name',
          label: 'Name'
        },
        {
          key: 'Key',
          label: 'Key'
        }
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Pushover'
    })
    this.LoadPushoverList()
  },
  methods: {
    Add() {
      this.modalText = 'Neuer Pushover Account'
      this.Reset()
      this.$bvModal.show('modal-edit-pushover')
      console.log(this.edit.IdentId)
    },
    ClickRow(record, index) {
      this.modalText = 'Pushover Account bearbeiten'
      this.edit.IdentId = record.IdentId
      this.edit.Key = record.Key
      this.edit.Name = record.Name
      this.$bvModal.show('modal-edit-pushover')
    },
    Delete(type) {

      this.$http.post('/pushover/delete', JSON.stringify({
        IdentId: this.edit.IdentId,
      }))
          .then(resp => {
            if (resp.data.success) {
              this.pushoverList = []
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Info',
                      icon: 'CheckIcon',
                      text: 'Pushover Account wurde gelöscht.',
                      variant: 'success',
                    },
                  },
                  {
                    timeout: 5000,
                  })
              this.$bvModal.hide('modal-edit-pushover')
              this.Reset()
              this.LoadPushoverList()
            } else {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: resp.data.message,
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            }
          })
          .catch(err => {
            this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: 'Es ist ein Fehler aufgetreten',
                    variant: 'danger',
                  },
                },
                {
                  timeout: 5000,
                })
          })

    },
    Save() {
      if (this.edit.IdentId == 0) {
        this.$http.post('/pushover/add', JSON.stringify({
          Name: this.edit.Name,
          Key: this.edit.Key,
        }))
            .then(resp => {
              if (resp.data.success) {
                this.pushoverList = []
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Info',
                        icon: 'CheckIcon',
                        text: 'Pushover Account wurde eingetragen.',
                        variant: 'success',
                      },
                    },
                    {
                      timeout: 5000,
                    })
                this.$bvModal.hide('modal-edit-pushover')
                this.Reset()
                this.LoadPushoverList()
              } else {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Fehler',
                        icon: 'CheckIcon',
                        text: resp.data.message,
                        variant: 'danger',
                      },
                    },
                    {
                      timeout: 5000,
                    })
              }
            })
            .catch(err => {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: 'Es ist ein Fehler aufgetreten',
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            })
      } else {
        this.$http.post('/pushover/edit', JSON.stringify({
          Name: this.edit.Name,
          Key: this.edit.Key,
          IdentId: this.edit.IdentId,
        }))
            .then(resp => {
              if (resp.data.success) {
                this.pushoverList = []
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Info',
                        icon: 'CheckIcon',
                        text: 'Pushover Account wurde geändert.',
                        variant: 'success',
                      },
                    },
                    {
                      timeout: 5000,
                    })
                this.$bvModal.hide('modal-edit-pushover')
                this.Reset()
                this.LoadPushoverList()
              } else {
                this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Fehler',
                        icon: 'CheckIcon',
                        text: resp.data.message,
                        variant: 'danger',
                      },
                    },
                    {
                      timeout: 5000,
                    })
              }
            })
            .catch(err => {
              this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: 'Es ist ein Fehler aufgetreten',
                      variant: 'danger',
                    },
                  },
                  {
                    timeout: 5000,
                  })
            })
      }
    },
    LoadPushoverList() {
      this.$http.get(`/pushover/list`)
          .then(resp => {
            resp.data.list.forEach(p => {
              this.pushoverList.push(p)
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    Reset() {
      this.edit = {
        Name: '',
        Key: '',
        IdentId: 0
      }
    },
  }
}
</script>